import { apiSlice } from '../../api/ApiService';

const getUserListApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserList: builder.query({
      query: ({ accessToken }: { accessToken: string | null}) => ({
        url: `/api/v1/Administration/users/?PageSize=500&PageIndex=1`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),
      providesTags: (result, error) => [
        { type: "AdminList" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserListQuery } = getUserListApi;
export default getUserListApi;
